export default __webpack_public_path__ + "static/media/finance.fb80ccd6.jpg";